
<template>
  <div>
<div  >





  <v-data-table

        no-data-text="На данный момент нет сохраненных процессов"
        :headers="headers"
        :items="history.foundData"
        item-key="name"
        hide-actions
        must-sort
        dense


        class="elevation-1"
      >
        <template slot="items" slot-scope="props"   >

          <td @click="result(props.item )" style="cursor:pointer">
            <v-layout row>
             <div style="margin-right:15px">
            <v-icon v-if="props.item.content_type == 'pages'"  large color="#273C51">mdi-account-search</v-icon>
            <v-icon v-else-if="props.item.content_type == 'groups'"  large color="green">mdi-account-group</v-icon>
            <v-icon v-else-if="props.item.content_type == 'topics'"  large color="yellow">mdi-message-reply-text</v-icon>
            <v-icon v-else-if="props.item.content_type == 'videos'"  large color="red">mdi-youtube</v-icon>
            <v-icon v-else-if="props.item.content_type == 'posts'"  large color="pink">mdi-comment-multiple-outline</v-icon>
            <v-icon v-else  large color="red">mdi-alert-circle</v-icon>
             </div>
              <v-flex>
          <div>  <span style="font-size:1.2em;font-weight:bold; color:#4A76A8"> {{ props.item.title   }}  </span> </div>
          <div>  <span style="color:#757575"> {{ props.item.title_desc   }}  </span> </div>
             </v-flex>
           </v-layout>

          </td>

          <td @click="result(props.item )" >
             <v-btn flat>  <strong style="font-size:1.2em"> {{props.item.found_count}}  </strong>  </v-btn>

          </td>



          <td class="text-xs-right"><span style="font-size:1.1em;color:#858585">{{ props.item.created_date | dateFormat}}</span></td>

<td class="text-xs-right"><span v-if="props.item.process_status == 'off'" style="font-size:1.1em;color:#858585">{{ props.item.modify_date |   dateFormat }}</span>
<span v-else style="font-size:1.2em;color:green;font-weight:bold"> Обновляется </span>
</td>


<td  class="justify-right layout px-0">



<v-btn v-if="props.item.process_status == 'on'" style="padding-left:5px"  flat   color="primary"  @click="proccessOff(props.item)" >
<v-progress-circular
  @click="true"
  :rotate="180"
  :value="props.item.updating_percent"
  color="#008000"
>
  {{ props.item.updating_percent }}
</v-progress-circular>
<span style="margin-left:10px;text-transform:none;color:red">отменить</span>
</v-btn>


<v-tooltip v-if="props.item.process_status == 'off'" top max-width="250"> <v-btn icon slot="activator" >  <v-icon @click="updateResult(props.item)"  > mdi-update </v-icon> </v-btn><span>Обновить результат процесса</span> </v-tooltip>
<v-tooltip v-if="props.item.process_status == 'off'" top max-width="250"> <v-btn icon slot="activator">  <v-icon @click="getInf(props.item)"> mdi-information </v-icon></v-btn> <span>Информация о процессе</span> </v-tooltip>
<v-tooltip v-if="props.item.process_status == 'off'" top max-width="250"> <v-btn icon slot="activator"> <v-icon   @click="del(props.item.process_id)"> mdi-delete </v-icon></v-btn> <span>Удалить процесс из истории</span> </v-tooltip>

</td>

        </template>
      </v-data-table>
</div>




<v-dialog v-model="results.modal" scrollable width="900" persistent  fullheight>
<result :results = "results"></result>
</v-dialog>

<v-dialog v-model="updateHistory.modal" scrollable width="900" persistent>
<updateHistory :results = "updateHistory"></updateHistory>
</v-dialog>

</div>
</template>

<script>

import axios from 'axios'
import result from './result.vue'
import updateHistory from './updater.vue'
export default {
components: {result,updateHistory},
props:['history' ],
  data () {
    return {

  updateHistory: {
    selectedProccess : {},
    selectedProccessPath: "",
    loadingMore:false,
    modal:false,
    updating: {
      intervalSet: {
        sec: 59,
        min: 9,
        hours: 0,
      },
      inProccess : false,
      interval: 7,
      timer: 35,
      auto: false,
      updatingPercent: 0,

    },
    lastHistory: [],
    actualHistory: [],
    contentType: "updating",
    contentMode: "newIn",  // newOut
    newIn: {
      foundData:{
       selector: false,
       foundIds: [1],
       displayIds: [],
       selectedIds: [],
       offset: 0,
       selectAll: false
     }
    },
    newOut: {
      foundData:{
       selector: false,
       foundIds: [],
       displayIds: [],
       selectedIds: [],
       offset: 0,
       selectAll: false
     }

    },
    newInContentMenegment: {
      marginTop: '0px',
      snackbarAbsoute: true,
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'pages',
      },
      autoExport: {
        isActive: false,
        tasksList:[],
     },


   },
   newOutContentMenegment: {
     marginTop: '0px',
     snackbarAbsoute: true,
     items: {
       selector: {active:true},
       copy: {active:true},
       export: {active:true},
       update: {active:false},
       delete: {active:false},
       autoExport: {active:false}
     },
     contentInfo: {
       type: 'pages',
     },
     autoExport: {
       isActive: false,
       tasksList:[],
    },


  },
  },

   results:{
     loadingMore:false,
     modal:false,
     procInfo: {},   // информация о процессе результаты которого просматриваются
     contentType: "",
     foundData:{
      selector: false,
      foundIds: [],
      displayIds: [],
      selectedIds: [],
      offset: 0,
      selectAll: false
    },


    pagesContentMenegment: {
      snackbarAbsoute: true,
      items: {
        selector: {active:true},
        copy: {active:true},
        export: {active:true},
        update: {active:false},
        delete: {active:false},
        autoExport: {active:false}
      },
      contentInfo: {
        type: 'pages',
      },
      autoExport: {
        isActive: false,
        tasksList:[],
     },


   },




   },






    inf: {
  modal:false,
    },
      headers: [
        {
          text: 'Название процесса',
          align: 'left',
          sortable: false,
          value: 'process_name'
        },
        {
          text: 'Результат',
          align: 'left',
          sortable: false,
          value: 'found_count'
        },
        {
         text: 'Дата создания',
          align: 'center',
         value: 'created_date'
       },
       {
        text: 'Дата обновления',
         align: 'center',
        value: 'modify_date'
      },
       {
        text: 'Операции',
        align: 'center',
       sortable: false,
      },

      ],



    }
  },
methods:{

 filter(){
    return 4
  },

 getInf(item){
   this.history.selectedProc = item
   this.history.infModal = true
   console.log(this.history.selectedProc)
 },


  updateResult(process){
    this.updateHistory.updating.inProccess = true
    this.updateHistory.selectedProccess = process
    this.updateHistory.modal = true

  },

  proccessOff(id) {

      axios( 'http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/proccess_off.php', {
           method: 'POST',
           data: {
             id: id.process_id,

           }
         })
         .then( response => {
      id.process_status = 'off'
         })


  },


  del(id){

    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/delete_history.php', {
         method: 'POST',
         data: {
           process_id: id
         }
       })
       .then( response => {
        this.history.catData = response.data
        this.$store.dispatch('changeCounters')
       })
  },
  info : function(id){
    this.inf.modal = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/process_info.php', {
         method: 'POST',
         data: {
           process_id: id
         }
       })
       .then( response => {
         //this.history.foundData = response.data
          //console.log(this.history.foundData)
       })
  },
  infClose: function(){
    this.inf.modal = false
  },
  result (item){
    this.results.procInfo = item
    this.results.pagesContentMenegment.contentInfo.type =  item.content_type
    this.results.modal = true
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/parser/process_results.php', {
         method: 'POST',
         data: {
           process_id: item.process_id,
           process_name: item.process_name,
         }
       })
       .then( response => {
          this.results.contentType = response.data.content_type
          this.results.foundData.foundIds = response.data.result_history.split(',')




       })
  },


},
computed: {

},
filters:{

  dateFormat(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Май.','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];

    let d =  new Date(item * 1000)

    return  d.getDate()+" "+months[d.getMonth()]+" в "+ d.getHours() +":"+ d.getMinutes()
  }
},
}
</script>

<style  >
 .actives {
   border-radius:50%;
   background-color: #C46B19;
   padding:5px;
 }
</style>
